import { Slot } from '@radix-ui/react-slot'
import React from 'react'
import { cn } from '#app/utils/styles.ts'

const Page = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement> & { asChild?: boolean }
>(({ className, asChild, ...props }, ref) => {
	const Comp = asChild ? Slot : 'div'
	return (
		<Comp
			ref={ref}
			className={cn(
				'flex w-full flex-col items-center gap-4 pb-2 md:mx-40',
				className,
			)}
			{...props}
		/>
	)
})
Page.displayName = 'Page'

const PageTitle = React.forwardRef<
	HTMLSpanElement,
	React.HTMLAttributes<HTMLSpanElement> & { asChild?: boolean }
>(({ className, asChild, ...props }, ref) => {
	const Comp = asChild ? Slot : 'span'
	return (
		<Comp
			ref={ref}
			className={cn('flex w-full max-w-sm items-center gap-4', className)}
			{...props}
		/>
	)
})
PageTitle.displayName = 'PageTitle'

const PageContent = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement> & { asChild?: boolean }
>(({ className, asChild, ...props }, ref) => {
	const Comp = asChild ? Slot : 'span'
	return (
		<Comp
			ref={ref}
			className={cn('mt-4 flex w-full max-w-sm flex-col gap-4', className)}
			{...props}
		/>
	)
})
PageContent.displayName = 'PageContent'

export { Page, PageTitle, PageContent }
